import { OfferFragment, OfferUpdateInput } from '@occc/graphql';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';

import { PromptAtPumpFormValues } from './types';

export const getPromptAtPumpInitialValues = (offer: OfferFragment): PromptAtPumpFormValues => {
  return {
    promptAtPump: {
      isEnabled: offer.optionalAtPos ?? false,
      shortPrompt: offer.shortDescription ?? '',
      longPrompt: offer.longDescription ?? '',
    },
  };
};

export const getOfferUpdateInputForPromptAtPump = (
  offer: OfferFragment | undefined | null,
  values: PromptAtPumpFormValues,
): OfferUpdateInput | null => {
  if (!offer) {
    return null;
  }

  const { isEnabled, shortPrompt, longPrompt } = values.promptAtPump;
  const shortDescription = shortPrompt ?? null;
  const longDescription = longPrompt ?? null;

  const input: OfferUpdateInput = {
    id: offer.id,
    shortDescription: isEnabled ? shortDescription : null,
    longDescription: isEnabled ? longDescription : null,
    optionalAtPos: isEnabled,
  };

  return input;
};

export const getOfferUpdateInputToClearPromptAtPump = (offer: OfferFragment) => {
  const input: OfferUpdateInput = {
    id: offer.id,
    shortDescription: null,
    longDescription: null,
    optionalAtPos: false,
  };

  return input;
};

export const getIsAnyPayAtPumpFieldDirty = (dirtyFields: DirtyFieldsType) => {
  return (
    isFieldDirty<PromptAtPumpFormValues>(dirtyFields, 'promptAtPump.isEnabled') ||
    isFieldDirty<PromptAtPumpFormValues>(dirtyFields, 'promptAtPump.shortPrompt') ||
    isFieldDirty<PromptAtPumpFormValues>(dirtyFields, 'promptAtPump.longPrompt')
  );
};

export const getPromptAtPumpOperations = (
  offer: OfferFragment | undefined | null,
  values: PromptAtPumpFormValues,
  dirtyFields: DirtyFieldsType,
) => {
  const isAnyPayAtPumpFieldDirty = getIsAnyPayAtPumpFieldDirty(dirtyFields);

  if (isAnyPayAtPumpFieldDirty) {
    const input = getOfferUpdateInputForPromptAtPump(offer, values);

    if (!input) {
      return [];
    }

    const operation: Operation = {
      name: 'offerUpdate',
      variables: {
        input,
      },
    };

    return [operation];
  }

  return [];
};
